import { Button, Flex, Popover, PopoverContent, PopoverTrigger, Switch, Text } from '@chakra-ui/react';
import { setActiveWidget, useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectWidgetProperty } from 'modules/Editor/store/infographSelector';
import { updateWidget } from 'modules/Editor/store/infographSlice';
import { useTranslation } from 'react-i18next';
import { LabelTextWidgetData } from 'widgets/TextBasedWidgets/LabelTextWidget/LabelTextWidget.types';
import { useWidget } from 'widgets/sdk';

import { isLabelHidden } from '../StatChartWidget.helpers';
import { ComponentWidgetIdKeys, StatChartWidgetData } from '../StatChartWidget.types';

export const ToggleMenu = () => {
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'statChartToolbar.toggleMenu',
    useSuspense: false,
  });
  const heading = t('title');
  const valueLabel = t('valueLabel');

  return (
    <Popover placement={'bottom-start'} closeOnEsc isLazy>
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button size='sm' fontWeight='semibold' variant={'icon-btn-toolbar-option'} isActive={isOpen}>
              {heading}
            </Button>
          </PopoverTrigger>
          <ToggleMenuContent valueLabel={valueLabel} />
        </>
      )}
    </Popover>
  );
};

interface ToggleMenuContentProps {
  valueLabel: string;
}
const ToggleMenuContent = ({ valueLabel }: ToggleMenuContentProps) => {
  const { widgetId, componentWidgetIdMap, metricTextEnabled } = useWidget<StatChartWidgetData>();
  const dispatch = useAppDispatch();

  const labelTextWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.MetricText];
  const labelTextIsHidden = useAppSelector(
    selectWidgetProperty<LabelTextWidgetData, 'isHidden'>(labelTextWidgetId, 'isHidden'),
  );
  const isHidden = isLabelHidden({ metricTextEnabled, isWidgetHidden: labelTextIsHidden });

  const onToggleMetricTextEnabled = () => {
    dispatch(updateWidget({ widgetId: labelTextWidgetId, widgetData: { isHidden: !isHidden } }));
    // Have to reselect the base widget to update the reset the bounding box rect entirely
    // since one group member is removed/added
    setTimeout(() => dispatch(setActiveWidget({ widgetId, isInitial: true })), 0);
  };

  const switchId = 'icon-stat-label-switch';

  return (
    <PopoverContent w={'100%'} boxShadow='md'>
      <Flex justify='space-between' w='11rem' align='center' p={2} pt={3}>
        <Text fontSize='sm' as='label' htmlFor={switchId}>
          {valueLabel}
        </Text>
        <Switch id={switchId} isChecked={!isHidden} onChange={onToggleMetricTextEnabled} />
      </Flex>
    </PopoverContent>
  );
};
